import { Navigate } from 'react-router-dom';
import { useUser } from '../hooks';

interface ProtectedRouteProps {
	access?: number | number[];
	children: JSX.Element;
}

var ProtectedRoute = ({ access, children }: ProtectedRouteProps)=>{
	var { hasAccess } = useUser();

	if (access !== undefined && !hasAccess(access)) {
		return <Navigate to="/" replace />;
	}

	return children;
};

export default ProtectedRoute;
